module.exports = __webpack_public_path__ + "img/action_polygon.91e60635.svg";